export default function Release20230918() {
    return (
        <>
            <p>
                Internetudbyderen Hiper, der med et glimt i øjet bryster sig af kun at være gode til internet, bliver nu en valgmulighed for de 50.000 husstande,
                der er tilkoblet GlobalConnect Privats fiberkabler &ndash; og det bringer selvsagt glæde hos Hiper:
            </p>
            <p>
                &ldquo;Vi er rigtig glade for nu at kunne åbne for 50.000 nye husstande via GlobalConnect Privats fibernetværk.
                       Vi har et benhårdt fokus på at levere lynhurtigt og driftssikkert internet til så mange danskere som muligt.
                       Her spiller fiber en stor rolle, da det uden tvivl er den type forbindelse, der giver højest hastighed og bedst kvalitet.
                       Om det er til gaming, streaming eller videomøder fra hjemmekontoret, så ved vi, at de fleste danskere går op i,
                       at det bare fungerer og er hurtigt.&rdquo;
                       lyder det fra Mads Hein, direktør for Hiper.
            </p>
            <p>
                <strong>1000/1000 mbit til kun 319 kroner</strong><br/>
                Lanceringen har man valgt fra Hipers side at markere med et attraktivt tilbud for de nye potentielle kunder på GlobalConnects fibernet,
                der dermed kan få lynhurtigt 1000/1000 mbit forbindelse til kun 319 kr.
                Samtidig kan kunderne få de første seks måneder til kun 199 kr om måneden.
            </p>
            <p>
                &ldquo;For fjerde år i træk blev Hiper tidligere på året kåret af analyseinstituttet Loyalty Group til at være den internetudbyder,
                       der giver kunderne mest værdi for pengene og samtidig den som flest vil anbefale.
                       Det vil vi gerne blive ved med &ndash; og det vil nye kunder på GlobalConnect Privat netværket også opleve.&rdquo; afslutter Mads Hein.
            </p>
            <p>
                <strong>Om Hiper</strong><br/>
                Hiper leverer lynhurtigt bredbånd og dækker over to millioner danske husstande med 1.000 Mbit.
                Hiper er tre år i træk blevet kåret til den internetudbyder, der giver kunderne mest værdi for pengene af analyseinstituttet Loyalty Group
                og løb også i 2022 med sejren for prisen &lsquo;Flest vil anbefale&rsquo;.
                Hiper er en del af Nuuday-koncernen.
            </p>
            <p>
                <strong>Om GlobalConnect</strong><br/>
                GlobalConnect Privat(tidligere Onefiber) er GlobalConnect Danmarkssatsning på privatmarkedet,
                som udbygger fibernet til private husstande i en lang række områder i landet.
            </p>
            <p>
                GlobalConnect-koncernen leverer højhastigheds fiber til 700.000 private hjem og helhedsløsninger fra fiber til sky til 30.000 erhvervskunder,
                baseret på 150.000 km fibernetværk og 35.000 kvadratmeter datacenterplads i Danmark, Norge, Sverige, Tyskland og Finland.
                Koncernen har cirka 1.800 medarbejdere og er ejet af kapitalfonden EQT.
            </p>
        </>
    )
}
